import { FC, useState } from "react";
import "./URMembershipPlanDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import appIcon from "../../../assets/images/ur-membership-app-logo.svg";
import planTickIcon from "../../../assets/images/membership-plan-tick-icon.svg";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import coinIcon from "../../../assets/images/ur-wallet-coins-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useTabBar } from "services/TabBarProvider";
import { DATE_FORMAT, MENU_ITEM } from "utils/constants";
import { membershipPlanTypes } from "utils/utils";
import dayjs from "dayjs";
import BecomeMemberDialog from "components/elements/BecomeMemberDialog";
import { getMembershipCardImage } from "utils/utils";
import { useStorage } from "services/StorageProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackMembershipApplied } from "utils/analytics";

const URMembershipPlanDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();
  const { userProfileData } = useStorage();
  const [showBecomeMemberDialog, setShowBecomeMemberDialog] =
    useState<boolean>(false);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveNowClick = () => {
    navigate(-1);
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const handleEventCardClick = (index: number) => {
    if (index === 0) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_DF_WORKSPACE_DETAIL, {
        state: { from: location.pathname },
      });
    } else if (index === 1) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_MB_STUDIO_DETAIL, {
        state: { from: location.pathname },
      });
    } else if (index === 2) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_EVENT_DETAIL, {
        state: { from: location.pathname },
      });
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="ur-membership-plan-detail-screen-container">
        <div className="ur-membership-plan-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">UR Wallet</div>
        </div>
        <div className="ur-membership-plan-detail-card-container">
          {userProfileData?.credit?.membership ? (
            <div className="image-text-container">
              <img
                className="card-image"
                src={getMembershipCardImage(
                  userProfileData?.credit?.membership?.membership_type,
                )}
                alt="membership-card"
              />
              <div className="custom-text-overlay"></div>
            </div>
          ) : (
            <div className="non-member-card">
              <div className="sub-container">
                <img src={appIcon} alt="ur-membership-app-icon" />
              </div>
            </div>
          )}
          <div className="right-container">
            <span className="header-text">Current Balance</span>
            <div className="total-credit-container">
              <img src={coinIcon} alt="ur-wallet-coin-icon" />
              {`${userProfileData?.credit?.credit_balance} Credits`}
            </div>
            {userProfileData?.credit?.membership_end_date && (
              <span style={{ color: "#A3A3AA" }}>
                Valid Upto :{" "}
                {dayjs(userProfileData?.credit?.membership_end_date).format(
                  DATE_FORMAT,
                )}
              </span>
            )}
          </div>
        </div>

        {membershipPlanTypes.map((data: any, index: number) => (
          <div
            key={index}
            className="ur-membership-plan-credit-details-container"
            onClick={() => handleEventCardClick(index)}
          >
            <div className="sub-container">
              <div style={{ width: "100%", display: "flex" }}>
                <img src={planTickIcon} alt="plan-tick-icon" />
                <span>
                  {data.title}
                  <span style={{ color: "#FF6B35" }}> {data.subTitle}</span>
                </span>
              </div>
              {data.creditType && (
                <div className="credit_container">
                  <div className="title">{`${
                    userProfileData?.credit?.[data.creditType]
                  }`}</div>
                  <div className="sub-title">Credit</div>
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="ur-membership-plan-detail-screen-bottom-container">
          <div className="button" onClick={handleReserveNowClick}>
            Reserve Now
            <img src={letsDoItIcon} alt="lets-do-it-logo" />
          </div>
          {!userProfileData?.credit?.membership && (
            <div
              className="more-benifits"
              onClick={() => {
                trackMembershipApplied();
                setShowBecomeMemberDialog(true);
              }}
            >
              Unlock More Benefits
            </div>
          )}
        </div>
      </div>
      <BecomeMemberDialog
        profileStatus={userProfileData?.credit?.status}
        open={showBecomeMemberDialog}
        onClose={() => setShowBecomeMemberDialog(false)}
      />
    </div>
  );
};

export default URMembershipPlanDetailScreen;
